import * as React from 'react';
import { connect } from 'react-redux';
import { loadDynamicForm } from '../../actions/dynamicFormAction';
import DynamicForm from '../../components/DynamicForm/DynamicForm';
import { config } from '../../config';
import { IPageDataReducer } from '../../reducers/pageData';
import { IStandardContentPageReducer } from '../../reducers/standardContentPage';
import { FAQContact } from '../FAQ/components/FAQContact';

const style: Record<string, React.CSSProperties> = {
    headerImage: {
        maxWidth: '100%',
        width: '100%',
        maxHeight: 300,
    },
};

interface DispatchProps {
    loadDynamicForm: Function;
}

interface StateProps {
    pageData: IPageDataReducer;
    standardContentPage: IStandardContentPageReducer;
    phoneNumber: string;
    countryCode: string;
}

type Props = StateProps & DispatchProps;

class StandardContentPageClass extends React.Component<Props, any> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        if (this.props.standardContentPage?.contactForm) {
            this.props.loadDynamicForm(this.props.standardContentPage.contactForm);
        }
    }

    render() {
        const {
            content,
            additionalContent,
            title,
            headerImage,
            contactForm,
        } = this.props.standardContentPage;

        const { deviceType } = this.props.pageData;

        const isDesktop = deviceType === 'desktop';

        const Header = () => {
            const style = {
                header: {
                    backgroundImage: `url(${config.images}/common/faq_contact_background.jpg)`,
                },
            };
            return (
                <div className="standardContentPage--header" style={style.header}>
                    <div className="standardContentPage--header-overlay" />
                    <div className="standardContentPage--header-data">
                        <h1 className="roundtrip-responsive">{title}</h1>
                    </div>
                </div>
            );
        };

        if (isDesktop) {
            return (
                <>
                    <Header />
                    <div className="standardContentPage--container">
                        <FAQContact
                            countryCode={this.props.countryCode}
                            phoneNumber={this.props.phoneNumber}
                            contactPageUrl={this.props?.pageData?.brandConfig?.contactPagePath}
                        />
                        <div className="standardContentPage--content">
                            {headerImage && (
                                <img alt={''} src={headerImage} style={style.headerImage} />
                            )}
                            {content && <div dangerouslySetInnerHTML={{ __html: content }} />}
                            {additionalContent && (
                                <div dangerouslySetInnerHTML={{ __html: additionalContent }} />
                            )}
                            {contactForm && (
                                <div id="contactus">
                                    <DynamicForm className="dynamicForm" headline={title} />
                                </div>
                            )}
                        </div>
                    </div>
                </>
            );
        }

        return (
            <>
                {headerImage && <img alt={''} src={headerImage} style={style.headerImage} />}
                <div
                    className="standardContentPage"
                    dangerouslySetInnerHTML={{ __html: content.trim() }}
                />
                {contactForm && (
                    <div className="standardContentPage--contact-form" id="contactus">
                        <DynamicForm className="dynamicForm" headline={title} />
                    </div>
                )}
                {additionalContent && (
                    <div
                        className="standardContentPage--aditional-content"
                        dangerouslySetInnerHTML={{ __html: additionalContent }}
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state: StateProps) => ({
    pageData: state.pageData,
    standardContentPage: state.standardContentPage,
    phoneNumber: state.pageData.brandConfig.phoneNumber,
    countryCode: state.pageData.appConfig.countryCode,
});

const mapDispatchToProps = {
    loadDynamicForm,
};

export const StandardContentPage = connect<StateProps, any, any>(
    mapStateToProps,
    mapDispatchToProps,
)(StandardContentPageClass);

export default StandardContentPage;
